import React, { useEffect } from 'react'
import TextField from '../../elements/form/TextField'
import { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFees } from '../../../store/actions/feesActions';
import { ERROR } from '../../../store/types';
import { createInvoice } from '../../../store/actions/invoicesActions';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import NumberField from '../../elements/form/NumberField';
import PlusIcon from '../../elements/icons/PlusIcon';
import TrashIcon from '../../elements/icons/TrashIcon';
import Checkbox from '../../elements/form/Checkbox';

const CreateNewInvoice = ({closeFunction}) => {
    const invoiceFee = {
        fee: '',
        amount: 0,
        quantity: 1,
        total: 0
    }
    const [invoicePayload, setInvoicePayload] = useState({});
    const [invoiceFees, setInvoiceFees] = useState([invoiceFee]);
    const [scholarshipsApply, setScholarshipsApply] = useState(true)

    const [validationErrors, setValidationErrors] = useState({});
    const dispatch = useDispatch()
    const invoicesSelector = useSelector(state => state.invoices)
    const feesSelector = useSelector(state => state.fees)

    useEffect(() => {
        dispatch(fetchFees('', 0, 0))
        return () => {
            
        };
    }, [dispatch]);

    const updateFee = (index, field, value) => {
        let temp = [...invoiceFees]
        temp[index][field] = value
        setInvoiceFees(temp)
    }

    const addFee = () => {
        let temp = [...invoiceFees]
        temp.push(invoiceFee)
        setInvoiceFees(temp)
    }

    const removeFee = (index) => {
        let temp = [...invoiceFees]
        temp.splice(index, 1)
        setInvoiceFees(temp)
    }

    const validateForm = () => {
        let errors = {}
        if(!invoicePayload.name || invoicePayload.name === '') {
            errors.name = true
        }
        if(!invoicePayload.description || invoicePayload.description === '') {
            errors.description = true
        }
        if(invoicePayload.description > 120){
            errors.description = true
        }
        invoiceFees.forEach((fee, feeIndex)=>{
            if(!fee.fee || fee.fee === '') {
                errors[`fee-${feeIndex}-fee`] = true
            }
            if(!fee.quantity || fee.quantity < 1) {
                errors[`fee-${feeIndex}-quantity`] = true
            }
        })
        
        setValidationErrors(errors)

        return errors
    }


    const pushInvoice = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            const payload = {
                ...invoicePayload,
                scholarshipsApply,
                fees: invoiceFees.map(fee => {return {
                    fee: fee.fee,
                    quantity: fee.quantity
                }})
            }

            dispatch(createInvoice(payload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const invoiceTotal = () => {
        return invoiceFees.reduce((a, b) => a + (b.amount * b.quantity || 0), 0)
    }

    return (
        <div className='w-full'>
            <div className='pb-2 border-b'>
                <p className='text-sm'>Provide details of the invoice and select fees for the invoice.</p>
            </div>
            <div className='mt-2'>
                <TextField
                    inputLabel="Invoice name" 
                    fieldId="invoice-name" 
                    inputType="text" 
                    inputPlaceholder={`Eg: Term school fees`}
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setInvoicePayload({...invoicePayload, ...{name: value}})}}
                />
            </div>

            <div className='mt-1'>
                <TextField
                    inputLabel="Invoice Description" 
                    fieldId="invoice-description" 
                    inputType="text" 
                    inputPlaceholder={`Add a short description for the invoice`}
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setInvoicePayload({...invoicePayload, ...{description: value}})}}
                />
                {invoicePayload?.description?.length > 120 && <p className='text-xs text-red-600 mt-[7px]'>Description is too long, please keep description less than 120 characters</p>}
            </div>

            <p className='mt-4 mb-1 text-sm font-[500]'>Invoice Fees</p>
            <p className="text-sm text-gray-500">Please select fees and the quantity for each fee below. You can add more fees by clicking on "add fee".</p>

            <div className="flex items-center justify-between gap-x-4 mt-4 p-2 bg-gray-50">
                <div className='w-6/12'>
                    <p className='text-xs font-[500] text-gray-400'>Fee</p>
                </div>
                <div className='w-2/12 text-right'>
                    <p className='text-xs font-[500] text-gray-400'>Amount (₦)</p>
                </div>
                <div className='w-1/12'>
                    <p className='text-xs font-[500] text-gray-400'>Quantity</p>
                </div>
                <div className='w-3/12 text-right'>
                    <p className='text-xs font-[500] text-gray-400'>Total (₦)</p>
                </div>
                <div className='w-[50px]'>
                    
                </div>
            </div>
            {invoiceFees.map((fee, feeIndex)=>(<div className="flex items-center justify-between gap-x-4 mt-2">
                <div className='w-6/12'>
                    {feesSelector.fees.fees.length > 0 ? <AutocompleteSelect
                        selectOptions={feesSelector.fees.fees}
                        inputLabel=""
                        placeholderText={`Select a fee`}
                        titleField="name"
                        displayImage={false}
                        imageField=""
                        requiredField={true}
                        preSelected={ fee.fee }
                        preSelectedLabel="_id"
                        fieldId="fee-select"
                        position='bottom-[50px]'
                        hasError={validationErrors && validationErrors[`fee-${feeIndex}-fee`]}
                        // return id of accounts of the selected option
                        returnFieldValue={(value) => {
                            updateFee(feeIndex, 'fee', value?._id)
                            updateFee(feeIndex, 'amount', value?.amount)
                            updateFee(feeIndex, 'total', value?.amount * fee.quantity)
                        }}
                    /> 
                    : 
                    <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                        <p>There are no fees yet. To be able to choose a fee for this invoice, please navigate to fees on the menu bar and create a fee.</p>
                    </div>
                }
                </div>
                <div className='w-2/12 text-right'>
                    <p className='text-sm font-space-grotesk'>{(fee.amount/100).toLocaleString()}</p>
                </div>
                <div className='w-1/12'>
                    <NumberField
                        inputType="number" 
                        fieldId={`fee-${feeIndex}-quantity`}
                        inputLabel="" 
                        requiredField={true}
                        preloadValue={fee.quantity || ''}
                        hasError={validationErrors && validationErrors[`fee-${feeIndex}-quantity`]} 
                        returnFieldValue={(value)=>{
                            updateFee(feeIndex, 'quantity', value)
                            updateFee(feeIndex, 'total', fee?.amount * value)
                        }}
                    />
                </div>
                <div className='w-3/12 text-right'>
                    <p className='text-sm font-space-grotesk'>{(fee.total/100).toLocaleString()}</p>
                </div>
                <div className='w-[50px] h-[50px] flex items-center justify-center'>
                {feeIndex > 0 && <button onClick={()=>{removeFee(feeIndex)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                    <TrashIcon className={`w-5 h-5`} />
                </button>}
                </div>
            </div>))}
            <div className='flex items-center justify-between'>
                <button onClick={()=>{addFee()}} className='w-2/3 border border-dashed uppercase transition duration-200 border-gray-400 hover:border-gray-600 text-sm hover:text-gray-600 text-gray-400 mt-4 rounded flex items-center justify-center gap-x-1 p-3'><PlusIcon className="w-4 h-4" /> Add Fee</button>
                <div className='w-1/3 text-right'>
                    <p className='text-sm text-gray-400 mt-[10px]'>Invoice Total: <span className='text-gray-600 font-[550] font-space-grotesk text-lg'>₦{(invoiceTotal()/100).toLocaleString()}</span></p>
                </div>
                <div className='w-[50px]' />
            </div>

            <div className='my-8'>
                <div className='w-full flex items-start justify-between gap-x-[5px]'>
                    <div className='w-[30px]'>
                        <Checkbox
                            CheckboxLabel=""
                            checkboxToggleFunction={()=>{
                                setScholarshipsApply(!scholarshipsApply)
                            }} 
                            isChecked={scholarshipsApply} 
                            hasError={false} 
                        />
                    </div>
                    <div className='w-full'>
                        <h3 className='font-medium font-space-grotesk text-[15px] mb-1'>Scholarships Apply</h3>
                        <p className='text-sm text-gray-600'>Keep this box checked if scholarship discounts should be applied to this invoice. If unchecked, every assignee of this invoice wil be required to pay the full invoice amount, whether or not they're on scholarship.</p>
                    </div>
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create new invoice`}
                    buttonAction={()=>{pushInvoice()}}
                    processing={invoicesSelector.creatingInvoice}
                    />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default CreateNewInvoice